import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,CFormInput,CFormSelect,CFormSwitch,CInputGroup,CInputGroupText,CFormCheck,
	CCard,CCardHeader,CCardBody,CCardFooter,CButton,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialoglookup,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Terapi 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 15) : 100;//(uSettingObj.jml_tabel || 30);
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISUpdateallow			= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);
	const [uFirstload,setFirstload]		= React.useState(true);
	const [uTerapimainArr,setTerapimainArr]	= React.useState([]);
	const [uTerapimainID,setTerapimainID]	= React.useState(0);

	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uCabangIDinit		= (localStorage.getItem("lastcabangid")||"0")
	const uCabangIDselected	= (localStorage.getItem("cabangidselect")||uCabangIDinit)
	const uCabangselectObj	= uDatacabangArr.filter(vItems=> 
		(vItems.id).toString()===uCabangIDselected.toString());

	const uCabangIDArr		= uTokenObj.user_cabangarr ||[];
	const uCabangallowedArr	= (uTokenObj.userhak!=="FREEROLE") 
		? uDatacabangArr.filter(vItems=>uCabangIDArr.includes((vItems.id||"").toString()) )
		: uDatacabangArr; 

	//--END VIEWS_VARS--/

	//---TABEL_VARS--/
	const [uToggleeditObj,setToggleeditObj] 	= React.useState({});
	const [uEfekview2,setEfekview2] 			= React.useState(false);
	//---END TABEL_VARS--/

	//---DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]			= React.useState(false);
	const [uDlgformObj,setDlgformObj]				= React.useState({});

	//--TIDAK_DIPAKAI--/
	const [uInpcaptionterapi,setInpcaptionterapi] 	= React.useState("");
	const [uInpbiayabahanedit,setInpbiayabahanedit]	= React.useState(0);
	const [uInpbiayajasedit,setInpbiayajasaedit]	= React.useState(0);
	//--END TIDAK_DIPAKAI--/
	//---END DLG_FORM--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	//--DOM_VARS--/
	const uElJmlData	= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlToggledlg = () =>{ setDlgformshow(false) }
	const hdlKlikTambahjenisterapi = () => {
		setDlgformObj({
			dlg_header: "Tambah JENIS TERAPI",
			dlg_jenis: "JENISTERAPI",
			nama_terapi: "",
		});
		setDlgformshow(true);
	}
	const hdlKlikTerapilookup = () => {
		if(!uISHapusallow && (parseInt(uDlgformObj.tabel_id)||0) > 0) return;

		setDlglookupObj({
			dlg_header:"Lookup: DATA JENIS TERAPI",
			data_arr: uTerapimainArr.map(vItems => {
				return {
					id:vItems.id,
					caption:vItems.nama_terapi,
				}
			}),
		})
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0;

		const vArridx = UFunc.getObjectIndeks(uTerapimainArr,_IDITEM);
		setDlgformObj({...uDlgformObj,
			id_terapi: _IDITEM,
			nama_terapi: (uTerapimainArr[vArridx]||{}).nama_terapi,
		});
		setDlglookupshow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inpterapisub");
			vElFocus && vElFocus.focus();
		},300)
	}
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselect(vIdxRow);

		console.log("(Terapi - hdlKlikEdit) uDatamainArr[vArridx]: ",JSON.stringify(uDatamainArr[vArridx]));
		const vTerapiidx		= UFunc.getObjectIndeks(uTerapimainArr,uDatamainArr[vArridx].id_terapi);
		const vTerapinama 	= (uTerapimainArr[vTerapiidx]||{}).nama_terapi || "";
		setDlgformObj({
			dlg_header: "Edit Tarif Terapi: "+UFunc.Usercaptionfilter(uDatamainArr[vArridx].terapi_caption,4).toUpperCase(),
			dlg_jenis: "TERAPISUB",
			tabel_id: uDatamainArr[vArridx].id,
			id_terapi: uDatamainArr[vArridx].id_terapi,
			nama_terapi: vTerapinama,
			nama_terapi_sub: uDatamainArr[vArridx].nama_terapi_sub,
			kategori: uDatamainArr[vArridx].kategori,
			icd9_code: uDatamainArr[vArridx].icd9_code,
			icd9_name: uDatamainArr[vArridx].icd9_name,
			tarif_terapi: uDatamainArr[vArridx].tarif_terapi,
			fee_man_persen: uDatamainArr[vArridx].fee_man_persen,
			b_fxd_lab: uDatamainArr[vArridx].b_fxd_lab,
			b_fxd_terukur: uDatamainArr[vArridx].b_fxd_terukur,
			b_fxd_apd: uDatamainArr[vArridx].b_fxd_apd,
			b_fxd_charge: uDatamainArr[vArridx].b_fxd_charge,
			b_fxd_diskon: uDatamainArr[vArridx].b_fxd_diskon,
			b_var_pajak: uDatamainArr[vArridx].b_var_pajak,
			b_var_lain: uDatamainArr[vArridx].b_var_lain,
			status_program_diskon: uDatamainArr[vArridx].status_program_diskon || "TIDAK",
			cabang_allowed_arr: uCabangallowedArr,
			cabangid_selected_arr: [uCabangIDinit],
		})
		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		const vArridx		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vCaptionupper	= (uDatamainArr[vArridx].terapi_caption || "").toUpperCase();

		if(await Konfirm(
			"<p>Terapi: <b>"+vCaptionupper+"</b> Akan DIHAPUS.."+
			"<br/><small class='fst-italic'>Proses Hapus Tidak Dapat Diulangi dan Dibatalkan.</small>"+
			"</p>"+
			"<p class=''>Apakah Anda Yakin ?</p>"+
			"")) apiProseshapus(_IDTABEL);
	}
	const hdlChangeprogramdiskon = (_EV) => {//--TIDAK_DIPAKAI--/
		const vTabelid	= parseInt(_EV.target.value);
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		const vValue 	= (_EV.target.checked) ? "YA" : "TIDAK";

		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+vTabelid)
		setRowselect(vIdxRow);

		setToggleeditObj({
			jenis:"status_program_diskon",
			tabel_id:vTabelid,
			value:vValue,
			onchange:"YA",
		});
	}

	//--TIDAK_DIPAKAI--/	
	const hdlKlikInitedit = (_IDTABEL,_FIELDEDIT) => {
		initTabelawal();
		_IDTABEL 	= parseInt(_IDTABEL||0);
		_FIELDEDIT 	= (_FIELDEDIT||"").trim();
		if(_IDTABEL <= 0) return;
		if(_FIELDEDIT === "") return;

		const vArridx = UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		uDatamainArr[vArridx].init_fieldedit = _FIELDEDIT;
		let vElFocus;
		if(_FIELDEDIT==="BIAYABAHAN") {
			vElFocus = ("inpbiayabahan"+_IDTABEL);
			setInpbiayabahanedit(uDatamainArr[vArridx].biaya_bahan||0);
		}else if(_FIELDEDIT==="BIAYAJASA") {
			vElFocus = ("inpbiayajasa"+_IDTABEL);
			setInpbiayajasaedit(uDatamainArr[vArridx].biaya_jasa||0);
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vLokalfokus = document.getElementById(vElFocus);
			vLokalfokus && vLokalfokus.focus();
		},350);
		//setEfekview(!uEfekview);
	}
	const hdlKDownedit = (_IDTABEL,_FIELDEDIT,_EVN) => {
		//alert(_EVN.which)
		if(_EVN.which === 27) {
			_EVN.preventDefault();
			initTabelawal();
			return;
		}
		if(_EVN.which === 13) {
			_EVN.preventDefault();
			_EVN.stopPropagation();
			hdlKlikeditOK(_IDTABEL,_FIELDEDIT);
			return;
		}
	}
	const hdlKlikeditOK = (_IDTABEL,_FIELDEDIT) => {
		let vElFocus;
		if(_FIELDEDIT === "BIAYABAHAN") {
			vElFocus = document.getElementById("inpbiayabahan"+_IDTABEL);
			if(parseFloat(uInpbiayabahanedit) < 0) {
				vElFocus && vElFocus.focus();
				showToast("Biaya Bahan Tidak Valid !"); return;
			}
		}
		if(_FIELDEDIT === "BIAYAJASA") {
			vElFocus = document.getElementById("inpbiayajasa"+_IDTABEL);
			if(parseFloat(uInpbiayajasedit) < 0) {
				vElFocus && vElFocus.focus();
				showToast("Biaya JASA Tidak Valid !"); return;
			}
		}

		apiProsestabel(_IDTABEL,_FIELDEDIT)
	}
	//--END TIDAK_DIPAKAI--/	

	const hdlKlikDlgsimpan = () => {
		if(uDlgformObj.dlg_jenis === "JENISTERAPI") prosesDlgformterapijenis();
		else if(uDlgformObj.dlg_jenis === "TERAPISUB") prosesDlgformterapisub();
	}
	const hdlKlikTabeledit = (_JENIS,_IDTABEL) => {
		_JENIS 		= _JENIS || "";
		_IDTABEL	= parseInt(_IDTABEL)||0;

		const vArridx= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselect(vIdxRow);

		let vValue;
		if(_JENIS === "kategori")
			vValue = uDatamainArr[vArridx].kategori || "UMUM";
		else if(_JENIS === "tarif_terapi")
			vValue = parseFloat(uDatamainArr[vArridx].tarif_terapi) || 0;
		else if(_JENIS === "fee_man_persen")
			vValue = parseFloat(uDatamainArr[vArridx].fee_man_persen) || 0;
		else if(_JENIS === "b_fxd_diskon")
			vValue = parseFloat(uDatamainArr[vArridx].b_fxd_diskon) || 0;

		setToggleeditObj({
			jenis:_JENIS,
			tabel_id:_IDTABEL,
			value:vValue,
		});

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inptabeledit");
			vElFocus && vElFocus.focus();
		},300)
	}
	const hdlKDownTabel = (_EV) => {
		if(_EV.which === 27) {
			_EV.preventDefault();_EV.stopPropagation();
			setToggleeditObj({});
			return;
		}
		if(_EV.which === 13) {
			_EV.preventDefault();_EV.stopPropagation();
			hdlKlikTabelsimpan();
		}
	}
	const hdlKlikTabelsimpan = () => {
		//--VALIDASI--/
		const vElFocus = document.getElementById("inptabeledit");
		let vValue;
		if(uToggleeditObj.jenis === "kategori") {
			vValue = uToggleeditObj.value || "";
			if((vValue !== "UMUM" && vValue !== "SPESIALISTIK")) {
				vElFocus && vElFocus.focus();
				showToast("Kategori Terapi Tidak Valid !"); return;
			}
			//alert(vValue); return;
		}
		else if(uToggleeditObj.jenis === "tarif_terapi") {
			vValue = parseFloat(uToggleeditObj.value) || 0;
			if(vValue < 0) {
				vElFocus && vElFocus.focus();
				showToast("Tarif Terapi Tidak Valid !"); return;
			}
		}
		else if(uToggleeditObj.jenis === "fee_man_persen") {
			vValue = parseFloat(uToggleeditObj.value) || 0;
			if(vValue < 0 || vValue > 100) {
				vElFocus && vElFocus.focus();
				showToast("Fee Manajemen Tidak Valid !"); return;
			}
		}
		else if(uToggleeditObj.jenis === "b_fxd_diskon") {
			vValue = parseFloat(uToggleeditObj.value) || 0;
			if(vValue < 0) {
				vElFocus && vElFocus.focus();
				showToast("Diskon Tidak Valid !"); return;
			}
		}
		//--END VALIDASI--/

		apiProsestabel();
	}

	//--END HANDEL--/

	//--INIT--/
	const initTabelawal	= () => {
		uDatamainArr.map(vItems=>{
			vItems.init_process = false;
			vItems.init_fieldedit = "";
		});
		setInpcaptionterapi("")
		setInpbiayabahanedit(0)
		setInpbiayajasaedit(0)
		setEfekview2(!uEfekview2)
	}
	const prosesDlgformterapijenis = () => {
		let vElFocus = document.getElementById("inpformterapijenis");
		if((uDlgformObj.nama_terapi||"").trim() === "") {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Harus Diisi !"); return;
		}
		if((uDlgformObj.nama_terapi||"").length < 3) {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Tidak Valid (Min.3 Karakter) !"); return;
		}

		apiProsesterapijenis();
	}
	const prosesDlgformterapisub = () => {
		//--VALIDASI_INPUT--/
		let vElFocus = document.getElementById("btnlookupterapi");
		if((parseInt(uDlgformObj.id_terapi)||0) <= 0) {
			vElFocus && vElFocus.focus();
			showToast("Nama MAIN Terapi Harus Dipilih !"); return;
		}
		vElFocus = document.getElementById("inpterapisub");
		if((uDlgformObj.nama_terapi_sub||"").trim() === "") {
			vElFocus && vElFocus.focus();
			showToast("Nama Sub Terapi Harus Diisi !"); return;
		}
		if((uDlgformObj.nama_terapi_sub||"").length < 3) {
			vElFocus && vElFocus.focus();
			showToast("Nama Sub Terapi Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpicd9name");
		if((uDlgformObj.icd9_code||"").trim() !== "")
			if((uDlgformObj.icd9_name||"").trim() === "") {
				vElFocus && vElFocus.focus();
				showToast("Nama Tindakan ICD9-CM Harus Diisi !"); return;
			}
		vElFocus = document.getElementById("inpicd9code");
		if((uDlgformObj.icd9_name||"").trim() !== "")
			if((uDlgformObj.icd9_code||"").trim() === "") {
				vElFocus && vElFocus.focus();
				showToast("Nama KODE ICD9-CM Harus Diisi !"); return;
			}
		
		vElFocus = document.getElementById("inptarifterapi");
		if((parseFloat(uDlgformObj.tarif_terapi)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Tarif Terapi Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpfeemanajemen");
		if((parseFloat(uDlgformObj.fee_man_persen)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Fee Manajemen Tidak Valid !"); return;
		}
		
		vElFocus = document.getElementById("inpbfxdlab");
		if((parseFloat(uDlgformObj.b_fxd_lab)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Fixed Laboratorium Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpbfxdterukur");
		if((parseFloat(uDlgformObj.b_fxd_terukur)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Fixed Terukur Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpbfxdapd");
		if((parseFloat(uDlgformObj.b_fxd_apd)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Fixed APD Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpbfxdcharge");
		if((parseFloat(uDlgformObj.b_fxd_charge)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Fixed Charge Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpbfxdiskon");
		if((parseFloat(uDlgformObj.b_fxd_diskon)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Fixed Diskon Tidak Valid !"); return;
		}

		vElFocus = document.getElementById("inpbvarpajak");
		if((parseFloat(uDlgformObj.b_var_pajak)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Variabel Pajak Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpbvarlain");
		if((parseFloat(uDlgformObj.b_var_lain)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Variabel Lain2 Tidak Valid !"); return;
		}
		if((uDlgformObj.cabangid_selected_arr||[]).length <= 0) {
			showToast("Cabang Harus Ada yang Dipilih !"); return;
		}

		const vBiayatotal = (parseFloat(uDlgformObj.b_fxd_lab)||0)
			+ (parseFloat(uDlgformObj.b_fxd_terukur)||0) 
			+ (parseFloat(uDlgformObj.b_fxd_apd)||0)
			+ (parseFloat(uDlgformObj.b_fxd_charge)||0)
			+ (parseFloat(uDlgformObj.b_fxd_diskon)||0)
			+ (parseFloat(uDlgformObj.b_var_pajak)||0)
			+ (parseFloat(uDlgformObj.b_var_lain)||0)
			+ 0; 
		vElFocus = document.getElementById("inptarifterapi");
		if((parseFloat(uDlgformObj.tarif_terapi)||0) < vBiayatotal) {
			vElFocus && vElFocus.focus();
			showToast("<p><b>Biaya Fixed dan Variabel Tidak Valid</b>..</p>"+
				"<p class='fst-italic'>Total Biaya Fixed dan Variabel Melebihi Tarif Terapinya.</p>"+
				"<p>Mohon Diperbaiki !</p>"+
				""); return;
		}

		//--END_VALIDASI_INPUT--/

		//showToast("YES"); return;
		apiProsessimpan();
	}
	//--END INIT--/

	//--CONTENT--/
	const contentMain = () => {
		if(uHtml500msg) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_terapicabang || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		let vDataviewArr	= uDatamainArr; 
		if((parseInt(uTerapimainID)||0) > 0) {
			vDataviewArr	= vDataviewArr.filter(vItems =>
				parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))
		}
		vDataviewArr	= vDataviewArr.slice(vMin,(vMax));

		//console.log("(Terapi - contentMain) vDataviewArr = "+JSON.stringify(vDataviewArr));

		const vColcaptionmd = (!uISUpdateallow) ? 7 : 5;
		const vColkategorimd = (!uISUpdateallow) ? 2 : 1;
		const vColnilaimd 	= (!uISUpdateallow) ? 3 : 6;

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={40} className="px-1"><small>No</small></th>
			<th className="px-0">
			<CRow className="mx-0">
			<CCol md={vColcaptionmd} className="text-start px-1"><small>{uBahasaObj.caption_namaterapi||"Nama Terapi"}</small></CCol>
			<CCol md={vColkategorimd} className="px-1"><small>Kategori</small></CCol>
			<CCol md={vColnilaimd} className="px-0 d-flex justify-content-between">
				<div className={"px-1 "+(uISUpdateallow ? "w-25" : "w-50")}><small>Tarif Terapi<div>(Rp)</div></small></div>
				{(uISUpdateallow) && (
				<>
				<div className="px-1 w-25"><small>B. Fixed & Vars<div>(Rp)</div></small></div>
				<div className="px-1 w-25"><small>Fee Manajemen</small></div>
				</>
				)}
				<div className={"px-1 "+(uISUpdateallow ? "w-25" : "w-50")}><small>Diskon<div>(Rp)</div></small></div>
			</CCol>
			</CRow>
			</th>
			<th width={uISUpdateallow ? 50 : "10%"} className="px-1 d-none"><small>Program Diskon</small></th>
			</tr>

			<tr className="d-md-none align-top classfontsmaller">
			<th width={30} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,nama_terapi,nama_terapi_sub,terapi_caption,
				tarif_terapi,b_fxd_lab,b_fxd_terukur,b_fxd_apd,
				b_fxd_charge,b_fxd_diskon,b_var_pajak,b_var_lain,
				kategori,fee_man_persen,status_program_diskon,
				inputlabel,tgl_input,icd9_code,icd9_name,
				init_process,init_fieldedit
			} = vItems;

			vNumber++;
			const vCaptionupper	= (terapi_caption||"").toUpperCase();

			const vTerapinama	= vKeyword==="" ? (nama_terapi||"UNDF TERAPI") 
				: (nama_terapi||"UNDF TERAPI").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTerapisubnama	= vKeyword==="" ? (nama_terapi_sub||"UNDF SUB TERAPI") 
				: (nama_terapi_sub||"UNDF SUB TERAPI").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTerapicaption	= vKeyword==="" ? (terapi_caption||"") 
				: (terapi_caption||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vKategori	= vKeyword==="" ? (kategori||"") 
				: (kategori||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vICD9code	= vKeyword==="" ? (icd9_code||"") 
				: (icd9_code||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vICD9name	= vKeyword==="" ? (icd9_name||"") 
				: (icd9_name||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			
			const vBiayatotal = (parseFloat(b_fxd_lab)||0)
				+ (parseFloat(b_fxd_terukur)||0) 
				+ (parseFloat(b_fxd_apd)||0)
				+ (parseFloat(b_fxd_charge)||0)
				+ (parseFloat(b_fxd_diskon)||0)
				+ (parseFloat(b_var_pajak)||0)
				+ (parseFloat(b_var_lain)||0)
				+ 0; 
			
			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}>
				<td className="px-1">{vNumber}.</td>

				<td className="px-1">
				<CRow className="mx-0">
					<CCol md={vColcaptionmd} className="px-1 text-start">
					<div className="d-flex justify-content-between">
						<div className="pe-1">
						<b className="text-uppercase">{UFunc.renderHTML(vTerapinama)}</b>
						<i className="ms-1 text-capitalize text-info">{UFunc.renderHTML(vTerapisubnama)}</i>
						</div>
						
						{(uISUpdateallow) && (
						<div className="ps-1">
							<CDropdown className="d-md-none">
							<CDropdownToggle caret={false} size="sm"
								className="p-0" 
								color="transparent">
								<CIcon icon="cilOptions" height={18}/>
							</CDropdownToggle>
							<CDropdownMenu>
								<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
									<CIcon className="classikonedit align-middle me-2" height={25}/>
									Edit Data Tarif
								</CDropdownItem>

								{(uISHapusallow) && (
								<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
									<CIcon className="classikonhapus align-middle me-2" height={25}/>
									Hapus Tarif
								</CDropdownItem>
								)}
							</CDropdownMenu>
							</CDropdown>

							<div style={{minWidth:60}} className="d-none d-md-block"> 
							<CTooltip className="d-none d-lg-block" content={"--Edit Terapi: "+vCaptionupper}>
							<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer"/>
							</CTooltip>

							{(uISHapusallow) && (
							<CTooltip className="d-none d-lg-block" content={"--Hapus Terapi: "+vCaptionupper}>
							<CLink onClick={()=>hdlKlikHapus(id)} className="classikontabel classikonhapus classcursorpointer"/>
							</CTooltip>
							)}
							</div>
						</div>
						)}
					</div>

					{((icd9_code||"").trim()!=="" && (icd9_name||"").trim()) && (
					<small className="d-none d-md-block fst-italic mt-1">
						<span className="me-1">&middot;</span>
						{UFunc.renderHTML(vICD9code)}
						<span className="mx-1">&middot;</span>
						{UFunc.renderHTML(vICD9name)}
						<span className="ms-1">&middot;</span>
					</small>
					)}

					<div className="d-none d-md-block mt-1 classfontsmaller text-danger">
						[<small>{UFunc.WaktuAngka(tgl_input)}</small>
						<small className="mx-1">&middot;</small>
						<small>{UFunc.Usercaptionfilter(inputlabel,1).toUpperCase()}</small>]
					</div>
					</CCol>

					<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

					{((icd9_code||"").trim()!=="" && (icd9_name||"").trim()) && (
					<>
					<CCol xs="4" className="px-1 text-start d-md-none"><small>ICD9 Code</small></CCol>
					<CCol xs="8" className="px-1 d-md-none">
						<small className="fst-italic">{UFunc.renderHTML(vICD9code)}</small>
					</CCol>

					<CCol xs="4" className="px-1 text-start d-md-none"><small>ICD9 Name</small></CCol>
					<CCol xs="8" className="px-1 d-md-none">
						<small className="fst-italic">{UFunc.renderHTML(vICD9name)}</small>
					</CCol>
					</>
					)}

					<CCol xs="5" className="px-1 text-start d-md-none">Kategori</CCol>
					<CCol xs="7" className="px-1 d-md-none">
						{(kategori||"UMUM")==="SPESIALISTIK" ? (
							<small className="text-success">
							{UFunc.renderHTML(vKategori)}
							</small>
						) : (<>{UFunc.renderHTML(vKategori)}</>)}
					</CCol>
					<CCol md={vColkategorimd} className="px-0 text-center d-none d-md-block">
						{(uToggleeditObj.jenis==="kategori" 
							&& parseInt(uToggleeditObj.tabel_id) === parseInt(id)
						) ? (
						<>
							{(init_process||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CRow className="">
							<CFormSelect size="sm"
								value={uToggleeditObj.value}
								onChange={(e)=>{
									setToggleeditObj({...uToggleeditObj,onchange:"YA",value:e.target.value});
								}}
								onKeyDown={(e)=>hdlKDownTabel(e)} 
								onBlur={()=>setToggleeditObj({})}
								id="inptabeledit">
							<option value="UMUM">UMUM</option>
							<option value="SPESIALISTIK">SPESIALISTIK</option>
							</CFormSelect>
							</CRow>
							)}
						</>
						) : (
						<>
							{(uISUpdateallow && !isMobile) ? (
							<CTooltip className="d-none d-lg-block" content="--Klik untuk EDIT..">
							<CLink onClick={()=>hdlKlikTabeledit("kategori",id)} style={{textDecoration: "underline dotted green 1px !important"}} className="classcursorpointer">
								{(kategori||"UMUM")==="SPESIALISTIK" ? (
									<small className="text-success">
									{UFunc.renderHTML(vKategori)}
									</small>
								) : (<>{UFunc.renderHTML(vKategori)}</>)}
							</CLink>
							</CTooltip>
							) : (
							<>
							{(kategori||"UMUM")==="SPESIALISTIK" ? (
								<small className="text-success">
								{UFunc.renderHTML(vKategori)}
								</small>
							) : (<>{UFunc.renderHTML(vKategori)}</>)}
							</>
							)}
						</>
						)}
					</CCol>

					<CCol md={vColnilaimd} className="px-0 d-none d-md-flex justify-content-between">
					<div className={"px-1 text-primary "+(uISUpdateallow ? "w-25" : "w-50")}>
						{(uToggleeditObj.jenis==="tarif_terapi" 
							&& parseInt(uToggleeditObj.tabel_id) === parseInt(id)
						) ? (
						<>
							{(init_process||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CInputGroup size="sm">
							<NumberFormat 
								value={uToggleeditObj.value}
								displayType={'text'} 
								allowNegative={false}
								thousandSeparator={"."} 
								decimalSeparator={","}
								onValueChange={(values) => {uToggleeditObj.value = values.value}}
								renderText={values => (
									<CFormInput size="sm"
										value={values}
										className="text-end"
										onFocus={(e)=>e.target.select()}
										onChange={(e)=>setToggleeditObj({...uToggleeditObj,value:e.target.value})}
										onKeyDown={(e)=>hdlKDownTabel(e)} 
									id="inptabeledit"/>
								)} 
							prefix={isMobile?"":"Rp"}/>

							<CButton onClick={()=>hdlKlikTabelsimpan()} size="sm" color="dark" id="btntabeledi">
								<CIcon icon="cilCheck"/>
							</CButton>
							</CInputGroup>
							)}
						</>
						) : (
						<>
							{(uISUpdateallow && !isMobile) ? (
							<CTooltip className="d-none d-lg-block" content="--Klik untuk EDIT..">
							<CLink onClick={()=>hdlKlikTabeledit("tarif_terapi",id)} style={{textDecoration: "underline dotted green 1px !important"}} className="classcursorpointer">
								{UFunc.formatAngka(tarif_terapi)}
							</CLink>
							</CTooltip>
							) : (
							<>
								{UFunc.formatAngka(tarif_terapi)}
							</>
							)}
						</>
						)}
					</div>

					{(uISUpdateallow) && (
					<>
					<div className="px-1 w-25">
						{UFunc.formatAngka(vBiayatotal)}
					</div>

					<div className="px-1 text-danger w-25">
						{(uToggleeditObj.jenis==="fee_man_persen" 
							&& parseInt(uToggleeditObj.tabel_id) === parseInt(id)
						) ? (
						<>
							{(init_process||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
								<CInputGroup size="sm">
								<CFormInput size="sm" type="number"
									className="text-end"
									min={0} max={100}
									value={uToggleeditObj.value}
									onFocus={(e)=>e.target.select()}
									onChange={(e)=>setToggleeditObj({...uToggleeditObj,value:e.target.value})}
									onKeyDown={(e)=>hdlKDownTabel(e)} 
									id="inptabeledit"/>
								<CButton onClick={()=>hdlKlikTabelsimpan()} size="sm" color="dark" id="btntabeledi">
									<CIcon icon="cilCheck"/>
								</CButton>
								</CInputGroup>
							)}
						</>
						) : (
						<>
							{(uISUpdateallow && !isMobile) ? (
							<CTooltip className="d-none d-lg-block" content="--Klik untuk EDIT..">
							<CLink onClick={()=>hdlKlikTabeledit("fee_man_persen",id)} style={{textDecoration: "underline dotted green 1px !important"}} className="classcursorpointer">
								<b>{UFunc.formatAngka(fee_man_persen)}%</b>
							</CLink>
							</CTooltip>
							) : (
							<b>{UFunc.formatAngka(fee_man_persen)}%</b>
							)}
						</>
						)}
					</div>
					</>
					)}

					<div className={"px-1 "+(uISUpdateallow ? "w-25" : "w-50")}>
						{(uToggleeditObj.jenis==="b_fxd_diskon" 
							&& parseInt(uToggleeditObj.tabel_id) === parseInt(id)
						) ? (
						<>
							{(init_process||false)===true ? (
								<CSpinner size="sm" color="primary"/>
							) : (
							<CInputGroup size="sm">
							<NumberFormat 
								value={uToggleeditObj.value}
								displayType={'text'} 
								allowNegative={false}
								thousandSeparator={"."} 
								decimalSeparator={","}
								onValueChange={(values) => {uToggleeditObj.value = values.value}}
								renderText={values => (
									<CFormInput size="sm"
										value={values}
										className="text-end"
										onFocus={(e)=>e.target.select()}
										onChange={(e)=>setToggleeditObj({...uToggleeditObj,value:e.target.value})}
										onKeyDown={(e)=>hdlKDownTabel(e)} 
									id="inptabeledit"/>
								)} 
							prefix={isMobile?"":"Rp"}/>
							<CButton onClick={()=>hdlKlikTabelsimpan()} size="sm" color="dark" id="btntabeledi">
								<CIcon icon="cilCheck"/>
							</CButton>
							</CInputGroup>
							)}
						</>
						) : (
						<>
							{(uISUpdateallow && !isMobile) ? (
							<CTooltip className="d-none d-lg-block" content="--Klik untuk EDIT..">
							<CLink onClick={()=>hdlKlikTabeledit("b_fxd_diskon",id)} style={{textDecoration: "underline dotted green 1px !important"}} className="classcursorpointer">
								{UFunc.formatAngka(b_fxd_diskon)}
							</CLink>
							</CTooltip>
							) : (
							<>
								{UFunc.formatAngka(b_fxd_diskon)}
							</>
							)}
						</>
						)}
					</div>
					</CCol>

					<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>
					
					<CCol xs="4" className="px-1 text-start d-md-none">Tarif Terapi</CCol>
					<CCol xs="8" md="2" className="px-1 d-md-none text-primary">
						{UFunc.formatAngka(tarif_terapi)}
					</CCol>

					{(uISUpdateallow) && (
					<>
					<CCol xs="6" className="px-1 text-start d-md-none">B.Fxd & Vars</CCol>
					<CCol xs="6" md="1" className="px-1 d-md-none">
						{UFunc.formatAngka(vBiayatotal)}
					</CCol>

					<CCol xs="5" className="px-1 text-start d-md-none">Fee Manajemen</CCol>
					<CCol xs="7" md="1" className="px-1 d-md-none fw-bolder text-danger">
						{UFunc.formatAngka(fee_man_persen)}%
					</CCol>
					</>
					)}

					<CCol xs="4" className="px-1 text-start d-md-none">Diskon</CCol>
					<CCol xs="8" md="2" className="px-1 d-md-none">
						{UFunc.formatAngka(b_fxd_diskon)}
					</CCol>

					<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

					<CCol xs="4" className="px-1 text-start d-md-none text-danger classfontsmaller">Input by</CCol>
					<CCol xs="8" className="px-1 d-md-none text-danger classfontsmaller">
						[<small>{UFunc.WaktuAngka(tgl_input)}</small>
						<small className="mx-1">&middot;</small>
						<small>{UFunc.Usercaptionfilter(inputlabel,1).toUpperCase()}</small>]
					</CCol>
				</CRow>
				</td>

				<td className="px-1 d-none text-center">
					{uISUpdateallow ? (
					<>
						{(uToggleeditObj.jenis==="status_program_diskon" 
							&& parseInt(uToggleeditObj.tabel_id) === parseInt(id)
							&& (init_process||false)===true
						) ? (
							<CSpinner size="sm" color="primary"/>
						) : (
						<CFormSwitch size="sm" className="mx-auto d-inline-block"
							checked={(status_program_diskon||"TIDAK")==="YA"}
							onChange={(e)=>hdlChangeprogramdiskon(e)}
							value={id}
							id={"inpdiskonstatus"+id}/>
						)}
					</>
					) : (
					<>
						{(status_program_diskon||"TIDAK")==="YA" ? (
						<CIcon icon="cilCheckCircle" className="text-danger" height={20}/>
						) : (
						<>&middot;</>
						)}
					</>
					)}
				</td>
			</tr>
			)//>
		})}
		</tbody>
		</table>
		)
	}
	const contentTerapimain = () => {
		if(uTerapimainArr.length <= 0) return ""

		return (
		<>
		{uTerapimainArr.map((vItems,vKeys)=>{
			const { nama_terapi,id } = vItems
			const vTerapisubArr	= uDatamainArr.filter(vItemsub => vItemsub.id_terapi === id);

			return (
				<option value={id} key={vKeys}>
					{(nama_terapi||"").toUpperCase()}
					&nbsp;&middot;&nbsp;
					({UFunc.formatAngka(vTerapisubArr.length)})
				</option>
			)//>
		})}
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		if(uDlgformObj.dlg_jenis === "TERAPISUB") return contentDlgformterapisub();
		if(uDlgformObj.dlg_jenis === "JENISTERAPI") return contentDlgformjenis();
		return (<></>)//>
	}
	const contentDlgformterapisub = () => {
		if(uDlgformObj.dlg_jenis !== "TERAPISUB") return (<></>)//>

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
		<CCol xs="4" className="">Jenis Terapi</CCol>
		<CCol>
			{(parseInt(uDlgformObj.id_terapi)||0) > 0 ? (
			<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					className="text-uppercase"
					value={uDlgformObj.nama_terapi}
					onClick={()=>hdlKlikTerapilookup()}
					id="inpterapimainform"/>
				<CButton size="sm" color="secondary"
					className="text-white"
					onClick={()=>hdlKlikTerapilookup()}
					id="btnlookupterapi">
					<CIcon icon="cilSearch"/>
				</CButton>
			</CInputGroup>
			) : (
			<div className="d-grid gap-2">
			<CButton size="sm" color="secondary" 
				onClick={()=>hdlKlikTerapilookup()}
				className="text-start text-white px-lg-3" 
				id="btnlookupterapi">
				<CIcon icon="cilSearch" className="me-1"/>
				Pilih JENIS TERAPI
			</CButton>
			</div>
			)}
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="">Nama Sub Terapi</CCol>
		<CCol className="">
			<CFormInput size="sm" maxLength={100}
				readOnly={!uISHapusallow && (parseInt(uDlgformObj.tabel_id)||0) > 0}
				value={uDlgformObj.nama_terapi_sub}
				onChange={(e)=>setDlgformObj({...uDlgformObj,nama_terapi_sub:e.target.value})}
				id="inpterapisub"/>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-3">
		<CCol xs="4" className="">Label Terapi</CCol>
		<CCol className="">
			{((uDlgformObj.nama_terapi||"").trim()==="" && (uDlgformObj.nama_terapi_sub||"").trim()==="") ? (
			<i className="text-muted">&middot;Belum Ada Label Terapi&middot;</i>
			) : (
			<>
			<b className="text-uppercase me-1">{uDlgformObj.nama_terapi}</b>
			<i className="text-capitalize">{uDlgformObj.nama_terapi_sub}</i>
			</>
			)}
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="">Kategori</CCol>
		<CCol xs="8" lg="4" className="">
			<CFormSelect size="sm"
				disabled={!uISHapusallow && (parseInt(uDlgformObj.tabel_id)||0) > 0}
				value={uDlgformObj.kategori}
				onChange={(e)=>setDlgformObj({...uDlgformObj,kategori:e.target.value})}
				id="inpkategori">
				<option value="UMUM">UMUM</option>
				<option value="SPESIALISTIK">SPESIALISTIK</option>
			</CFormSelect>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="4" className="">Kode ICD9 CM</CCol>
		<CCol xs="8" lg="4">
			<CFormInput size="sm" maxLength={10}
				className="text-uppercase"
				value={uDlgformObj.icd9_code}
				onChange={(e)=>setDlgformObj({...uDlgformObj,icd9_code:e.target.value})}
				id="inpicd9code"/>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4">Nama Resmi ICD9 CM</CCol>
		<CCol>
			<CFormInput size="sm" maxLength={100}
				className="text-capitalize"
				value={uDlgformObj.icd9_name}
				onChange={(e)=>setDlgformObj({...uDlgformObj,icd9_name:e.target.value})}
				id="inpicd9name"/>

			<div className="classpetunjuk px-0">
			*) Utk Referensi Penamaan & Kode, Kunjungi <a href="https://satusehat.kemkes.go.id/platform/docs/id/terminology/icd/icd-9-cm/" target="_blank">LINK SATUSEHAT Ini</a>.
			</div>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="4" className="text-primary fw-bolder">Tarif Terapi</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.tarif_terapi}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.tarif_terapi = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,tarif_terapi:e.target.value})}
					id="inptarifterapi"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-danger">Fee Manajemen</CCol>
		<CCol xs="8" md="4">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="number"
				min={0}
				max={100}
				className="text-end"
				value={uDlgformObj.fee_man_persen}
				onFocus={(e)=>e.target.select()}
				onChange={(e)=>setDlgformObj({...uDlgformObj,fee_man_persen:e.target.value})}
				id="inpfeemanajemen"/>
			<CInputGroupText className="text-danger">%</CInputGroupText>
			</CInputGroup>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>
		<div className="fw-bolder">BIAYA FIXED</div>
		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Laboratorium</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_fxd_lab}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_fxd_lab = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_fxd_lab:e.target.value})}
					id="inpbfxdlab"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Terukur</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_fxd_terukur}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_fxd_terukur = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_fxd_terukur:e.target.value})}
					id="inpbfxdterukur"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. APD</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_fxd_apd}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_fxd_apd = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_fxd_apd:e.target.value})}
					id="inpbfxdapd"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Charge</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_fxd_charge}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_fxd_charge = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_fxd_charge:e.target.value})}
					id="inpbfxdcharge"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Diskon</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_fxd_diskon}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_fxd_diskon = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_fxd_diskon:e.target.value})}
					id="inpbfxdiskon"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		{1===3 && (
		<CCol xs="12" lg="4" className="px-lg-1 text-end text-lg-start">
			<input type="checkbox" 
				checked={uDlgformObj.status_program_diskon==="YA"}
				onChange={(e)=>{
					if(e.target.checked)
						setDlgformObj({...uDlgformObj,status_program_diskon:e.target.value})
					else
						setDlgformObj({...uDlgformObj,status_program_diskon:"TIDAK"})
				}} 
				size="sm" value="YA" id="inpdiskonstatus"/>
			<label htmlFor="inpdiskonstatus" className="ms-1 classcursorpointer"><small>Ada Program Diskon</small></label>
		</CCol>
		)}
		</CRow>

		<div className="my-3 classborderbottom"/>
		<div className="fw-bolder">BIAYA VARIABEL</div>
		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Pajak</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_var_pajak}
				displayType={'text'} 
				thousandSeparator={"."} 
				allowNegative={false}
				decimalSeparator={","}
				onValueChange={(values) => {uDlgformObj.b_var_pajak = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_var_pajak:e.target.value})}
					id="inpbvarpajak"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="4" className="text-md-end">B. Lain-lain</CCol>
		<CCol xs="8" lg="4">
			<NumberFormat 
				value={uDlgformObj.b_var_lain}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				allowNegative={false}
				onValueChange={(values) => {uDlgformObj.b_var_lain = values.value}}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformObj({...uDlgformObj,b_var_lain:e.target.value})}
						onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpbvarlain"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>

		{uDatacabangArr.length > 1 && (
		<>
			{(parseInt(uDlgformObj.tabel_id)||0) > 0 && (
			<>
			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol xs="4" className="d-flex justify-content-between">
				<small className="fw-bolder">Harga Cabang UPDATE</small>

				<CLink onClick={()=>{
					if((uDlgformObj.cabang_allowed_arr||[]).length === (uDlgformObj.cabangid_selected_arr||[]).length) {
						setDlgformObj({...uDlgformObj,cabangid_selected_arr:[]});
					} else {
						setDlgformObj({...uDlgformObj,
							cabangid_selected_arr:(uDlgformObj.cabang_allowed_arr||[]).map(vItems=>vItems.id),
						});
					}
					}} className="classcursorpointer">
				<CIcon icon="cilCheckCircle" className="classikonbox" height={25}/>
				</CLink>
			</CCol>
			
			<CCol xs="8" lg="4" className="d-flex">
				{(uDlgformObj.cabang_allowed_arr||[]).map((vItems,vKeys)=>{
					const vTmpArr	= (uDlgformObj.cabangid_selected_arr||[]).
						filter(vItemselect => parseInt(vItemselect) === parseInt(vItems.id));

					const vISchecked = vTmpArr.length > 0;

					return (
					<span key={vKeys}>
					<div className="bg-light d-inline-block border rounded me-1 p-1 px-2">
						<input type="checkbox" checked={vISchecked}
							onChange={(e)=>{
								if(e.target.checked) {
									setDlgformObj({...uDlgformObj,
										cabangid_selected_arr: [...(uDlgformObj.cabangid_selected_arr||[]),e.target.value]
									})
								} else {
									const vDelidx = (uDlgformObj.cabangid_selected_arr||[]).indexOf(e.target.value);
									(uDlgformObj.cabangid_selected_arr||[]).splice(vDelidx,1);
									setEfekview(!uEfekview);
								}
							}}
							value={vItems.id}
							className="align-middle me-1" id={"inpcabandid"+vItems.id}/>
						
						<label htmlFor={"inpcabandid"+vItems.id} className="classcursorpointer">
							<small>{vItems.cabang_nama||"UNDF"}</small>
						</label>
					</div>
					</span>
					)
				})}
			</CCol>
			</CRow>
			</>
			)}
		</>
		)}
		</CForm>
		)//>
	}
	const contentDlgformjenis = () => {
		if(uDlgformObj.dlg_jenis !== "JENISTERAPI") return (<></>)//>

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
			<CCol xs="4">Nama Jenis Terapi</CCol>
			<CCol>
			<CFormInput size="sm" maxLength={100}
				value={uDlgformObj.nama_terapi}
				onChange={(e)=>setDlgformObj({...uDlgformObj,nama_terapi:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpformterapijenis"/>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoaddata = () => {
		setHtml500msg();

		setJmlData(0);
		setDatamainArr([]);
		setIDselect(0);
		setRowselect(-1);
		setPageActive(1);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiLoaddata) uFirstload = "+uFirstload)
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vKeyword 			= uKeywordObj.kwd_terapicabang || "";
		const vCabangIDselect 	= uCabangIDselected;
		const vDATAS	= JSON.stringify({
			send_firstload : uFirstload===true ? "YA" : "TIDAK",
			send_keyword : vKeyword,
			send_cabangid: vCabangIDselect,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapi/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpObj = JSON.parse(output_string.dataobject||"[]");
				setDatamainArr(vTmpObj);
				//setJmlData((parseInt(vTmpObj.length)||0));

				//console.log("(Terapi - apiLoaddata) send_firstload = "+output_string.send_firstload)
				setTerapimainArr(JSON.parse(output_string.dataterapi || JSON.stringify(uTerapimainArr)));
				if(uFirstload) setFirstload(false);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapi - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		const vTabelid 	= parseInt(uDlgformObj.tabel_id)||0;
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		const vElsbutton= document.getElementById("btnDialogSimpan");

		vElsbutton && (vElsbutton.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uCabangIDselected,
			send_parsobj: JSON.stringify({...uDlgformObj,
				dlg_header: undefined,
				dlg_jenis: undefined,
				cabang_allowed_arr: undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapi/pr_simpansub";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vElsbutton && (vElsbutton.disabled = false);
			if(output_string.sukses) {
				let vTmpnewObj = {
					...uDlgformObj,
					dlg_header: undefined,
					dlg_jenis: undefined,
					cabang_allowed_arr: undefined,
					cabangid_selected_arr: undefined,
				}
				const vTabelidnew	= parseInt(output_string.tabelidnew||"255");
				
				if(vTabelid <= 0) {
					vTmpnewObj = {...vTmpnewObj, id:vTabelidnew }
					setDatamainArr([vTmpnewObj,...uDatamainArr]);

					showToast((uBahasaObj.pesan_sukses || "Data Berhasil Disimpan.."),"SUKSES");
					setDlgformObj({
						...uDlgformObj,
						nama_terapi_sub:"",
						kategori: "UMUM",
						icd9_code:"",
						icd9_name:"",
						fee_man_persen: 8,
						tarif_terapi: 0,
						b_fxd_lab: 0,
						b_fxd_terukur: 0,
						b_fxd_apd: 0,
						b_fxd_charge: 0,
						b_fxd_diskon: 0,
						b_var_pajak: 0,
						b_var_lain: 0,
						status_program_diskon: "TIDAK",
						cabang_allowed_arr: uCabangallowedArr,
						cabangid_selected_arr: uCabangallowedArr.map(vItems=>vItems.id),
					});

					const vElFocus = document.getElementById("inpterapisub");
					if(!isMobile) vElFocus && vElFocus.focus();
				} else {
					uDatamainArr[vArridx] = {
						...(uDatamainArr[vArridx]||{}),
						...vTmpnewObj,
					}
					hdlToggledlg();
				}
			} if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			console.log("(Terapi - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesterapijenis = () => {
		const vElsbutton= document.getElementById("btnDialogSimpan");
		vElsbutton && (vElsbutton.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parsobj: JSON.stringify({...uDlgformObj,
				dlg_header: undefined,
				dlg_jenis: undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_simpan";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vElsbutton && (vElsbutton.disabled = false);
			if(output_string.sukses) {
				const vTmpObj = {
					id:output_string.tabelidnew || "255",
					nama_terapi: uDlgformObj.nama_terapi,
				}
				setTerapimainArr([vTmpObj,...uTerapimainArr]);

				showToast((uBahasaObj.pesan_sukses || "Data Berhasil Disimpan.."),"SUKSES");
				setDlgformshow(false);
			} if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiProsesterapijenis) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			console.log("(Terapi - apiProsesterapijenis) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsestabel = () => {
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,uToggleeditObj.tabel_id);

		let vValue;
		let vValuebefore;
		if(uToggleeditObj.jenis === "kategori") {
			vValuebefore 	= uDatamainArr[vArridx].kategori || "UMUM";
			vValue 			= uToggleeditObj.value || "";
		}
		else if(uToggleeditObj.jenis === "tarif_terapi") {
			vValuebefore 	= parseFloat(uDatamainArr[vArridx].tarif_terapi) || 0;
			vValue 			= parseFloat(uToggleeditObj.value) || 0;
		}
		else if(uToggleeditObj.jenis === "fee_man_persen") {
			vValuebefore 	= parseFloat(uDatamainArr[vArridx].fee_man_persen) || 0;
			vValue 			= parseFloat(uToggleeditObj.value) || 0;
		}
		else if(uToggleeditObj.jenis === "b_fxd_diskon") {
			vValuebefore 	= parseFloat(uDatamainArr[vArridx].b_fxd_diskon) || 0;
			vValue 			= parseFloat(uToggleeditObj.value) || 0;
		}
		else if(uToggleeditObj.jenis === "status_program_diskon") {
			vValuebefore 	= uDatamainArr[vArridx].status_program_diskon || "TIDAK";
			vValue 			= uToggleeditObj.value || "";
		}

		if(vValue === vValuebefore) {
			setToggleeditObj({}); return
		}
		uDatamainArr[vArridx]	= {
			...(uDatamainArr[vArridx]||{}),
			init_process: true,
		}
		setEfekview2(!uEfekview2);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsestabel) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			uDatamainArr[vArridx]	= {
				...(uDatamainArr[vArridx]||{}),
				kategori: (uToggleeditObj.jenis==="kategori" ? vValue : (uDatamainArr[vArridx]||{}).kategori),
				tarif_terapi: (uToggleeditObj.jenis==="tarif_terapi" ? vValue : (uDatamainArr[vArridx]||{}).tarif_terapi),
				fee_man_persen: (uToggleeditObj.jenis==="fee_man_persen" ? vValue : (uDatamainArr[vArridx]||{}).fee_man_persen),
				b_fxd_diskon: (uToggleeditObj.jenis==="b_fxd_diskon" ? vValue : (uDatamainArr[vArridx]||{}).b_fxd_diskon),
				status_program_diskon: (uToggleeditObj.jenis==="status_program_diskon" ? vValue : (uDatamainArr[vArridx]||{}).status_program_diskon),
				init_process: undefined,
			}
			setToggleeditObj({}); 

			//setEfekview2(!uEfekview2);
		},3000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uCabangIDselected,
			send_parsobj : JSON.stringify({...uToggleeditObj}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapi/pr_simpantabel";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.sukses) {
				let vDiskonstatus		= (uToggleeditObj.jenis==="status_program_diskon" ? vValue : (uDatamainArr[vArridx]||{}).status_program_diskon);
				if(uToggleeditObj.jenis==="b_fxd_diskon")
					vDiskonstatus = vValue > 0 ? "YA" : "TIDAK";

				uDatamainArr[vArridx]	= {
					...(uDatamainArr[vArridx]||{}),
					kategori: (uToggleeditObj.jenis==="kategori" ? vValue : (uDatamainArr[vArridx]||{}).kategori),
					tarif_terapi: (uToggleeditObj.jenis==="tarif_terapi" ? vValue : (uDatamainArr[vArridx]||{}).tarif_terapi),
					fee_man_persen: (uToggleeditObj.jenis==="fee_man_persen" ? vValue : (uDatamainArr[vArridx]||{}).fee_man_persen),
					b_fxd_diskon: (uToggleeditObj.jenis==="b_fxd_diskon" ? vValue : (uDatamainArr[vArridx]||{}).b_fxd_diskon),
					status_program_diskon: vDiskonstatus,
					init_process: undefined,
				}

				setToggleeditObj({}); 
			} else {
				uDatamainArr[vArridx].init_process = false;
				if(uToggleeditObj.jenis==="status_program_diskon") {
					setToggleeditObj({});
				}

				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Terapi - apiProsestabel) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}

				let vTimeout = setTimeout(()=>{
					clearTimeout(vTimeout);
					const vElFocus = document.getElementById("inptabeledit");
					vElFocus && vElFocus.focus();
				},300)
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx].init_process = false;
			if(uToggleeditObj.jenis==="status_program_diskon") {
				setToggleeditObj({});
			}
			console.log("(Terapi - apiProsestabel) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");

			let vTimeout = setTimeout(()=>{
				clearTimeout(vTimeout);
				const vElFocus = document.getElementById("inptabeledit");
				vElFocus && vElFocus.focus();
			},300)
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL		= parseInt(_IDTABEL)||0;
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			uDatamainArr.splice(vArridx,1);
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid: _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapi/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr.splice(vArridx,1);
				setEfekview(!uEfekview);
			} if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapi - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	apiLoaddata();

    	return () => {
			setDlgformshow(false);
			uDispatch({type: "set", gInitHeaderAction: {}});

    		setDatamainArr([]); setToggleeditObj({});
			setTerapimainArr([]); setFirstload(true);
    		localStorage.removeItem("cabangidselect")
    	}
	},[])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
	},[uDatamainArr.length])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		/*const vKeyword = uKeywordObj.kwd_terapicabang || "";
		if(vKeyword.length <= 2) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));

		const vEljmldatamobile = document.getElementById("idjmldatamobile");
		vEljmldatamobile && (vEljmldatamobile.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{
		setPageActive(1);

		let vJmldata;
		if(parseInt(uTerapimainID) > 0) {
			vJmldata = (uDatamainArr.filter(vItems => 
				parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))||[]).length;
		} else {
			vJmldata = uJmlData;
		}
		const vJmlHal	= Math.ceil(vJmldata / uMaxData);
		setJmlHal(vJmlHal);//-*/

		setEfekview(!uEfekview)
	},[uTerapimainID])
	React.useEffect(()=>{ setRowselect(-1); },[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;
		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setRowselect(-1);

		if(uHtml500msg) return;

		//--OPEN_DIALOG--/
		const vArridx		= UFunc.getObjectIndeks(uTerapimainArr,uTerapimainID);
		const vTerapinama 	= (uTerapimainArr[vArridx]||{}).nama_terapi || "";
		setDlgformObj({
			dlg_header: "Tambah Nama Terapi",
			dlg_jenis: "TERAPISUB",
			id_terapi: uTerapimainID,
			nama_terapi: vTerapinama,
			nama_terapi_sub: "",
			kategori: "UMUM",
			icd9_code:"",
			icd9_name:"",
			fee_man_persen: 5,
			tarif_terapi: 0,
			b_fxd_lab: 0,
			b_fxd_terukur: 0,
			b_fxd_apd: 0,
			b_fxd_charge: 0,
			b_fxd_diskon: 0,
			b_var_pajak: 0,
			b_var_lain: 0,
			status_program_diskon: "TIDAK",
			cabang_allowed_arr: uCabangallowedArr,
			cabangid_selected_arr: uCabangallowedArr.map(vItems=>vItems.id),
		})
		setDlgformshow(true);
		//--END OPEN_DIALOG--/
	},[uHandelTambah])
	/*React.useEffect(()=>{
		//console.log("("+cComponentName+"[uIsScrollBottom]) uIsScrollBottom: "+uIsScrollBottom);
		if(!isMobile) return;
		if(!uIsScrollBottom) return;
		
		const vPageNow	= uPageActive;
		if(vPageNow+1 > uJmlHal) return;
		setPageActive(vPageNow+1);
	},[uIsScrollBottom])//-*/
	React.useEffect(()=>{
		if(!uISDlgformshow) { setDlgformObj({}); return; }

		//console.log("("+cComponentName+"[uISDlgformshow]) uISDlgformshow 1: "+uISDlgformshow);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);

			let vElFocus = document.getElementById("inpterapisub");
			if(uDlgformObj.dlg_jenis === "JENISTERAPI")
				vElFocus = document.getElementById("inpformterapijenis");
			if(!isMobile)
				vElFocus && vElFocus.focus();
		},200);
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!(uDlgformObj||{}).b_fxd_diskon) return;

		if((parseFloat(uDlgformObj.b_fxd_diskon)||0) > 0)
			setDlgformObj({...uDlgformObj,status_program_diskon:"YA"});
		else
			setDlgformObj({...uDlgformObj,status_program_diskon:"TIDAK"});
	},[uDlgformObj.b_fxd_diskon])
	React.useEffect(()=>{
		setRowselect(-1);
		setIDselect(0);
	},[uTerapimainID])
	React.useEffect(()=>{
		if(uToggleeditObj.onchange!=="YA") return;

		if(uToggleeditObj.jenis==="kategori"
			|| uToggleeditObj.jenis==="status_program_diskon"
			) {
			setToggleeditObj({...uToggleeditObj,onchange:undefined});
			hdlKlikTabelsimpan();
		}
	},[uToggleeditObj.value])

	//console.log("Terapi - uPageActive => "+JSON.stringify(uPageActive));

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center px-1 px-md-3">
		<div className="d-flex align-items-center">
			<CInputGroup size="sm" className="align-items-center">
			{uDatacabangArr.length > 1 && (
			<>
				{uCabangselectObj.length > 0 && (
				<>
					<b className="d-none d-md-inline">{uCabangselectObj[0].cabang_nama}</b>
					<b className="d-md-none">{uCabangselectObj[0].cabang_kode}</b>
				</>
				)}
				<span className="mx-1">&middot;</span>
			</>
			)}
			<CFormSelect size="sm"
				style={{maxWidth:350}}
				onChange={(e)=>setTerapimainID(e.target.value)}
				value={uTerapimainID}
				id="inpterapimain">
				<option value="0">-- SEMUA JENIS TERAPI --</option>
				{contentTerapimain()}
			</CFormSelect>
			</CInputGroup>

			{uISUpdateallow && (
			<>
				<span className="mx-1 ms-2">&middot;</span>
			
				<CTooltip className="d-none d-lg-block" content="--Tambah Jenis Terapi">
				<CLink onClick={()=>hdlKlikTambahjenisterapi()} className="classcursorpointer">
				<CIcon icon="cibAddthis" className="classikonbox" height={25}/>
				</CLink> 
				</CTooltip>
			</>)}
		</div>

		<span className="text-muted classfontsmaller ps-1">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentMain()}</CCardBody>

		{(()=>{
			let vJmldata;
			if(parseInt(uTerapimainID) > 0) {
				vJmldata = (uDatamainArr.filter(vItems => 
					parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))||[]).length;
			} else {
				vJmldata = uJmlData;
			}
			
			if(vJmldata > uMaxData)
			return (
			<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/>
			</CCardFooter>
			)	
		})()}
		</CCard>

		<MyDialoglookup
			show={uISDlglookupshow} 
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			inputValue=""
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.dlg_header||""}
			toggle={hdlToggledlg}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Terapi